import { HEADER_HEIGHT, Screen } from '@bonanza-social/navigation';
import CommunityJackpot from '../../components/CommunityJackpot/CommunityJackpot';
import { Platform, View } from 'react-native';
import { Box } from '@bonanza-social/moonlight';

function CommunityJackpotScreen() {
  const isWeb = Platform.OS === 'web';

  return (
    <Box flex={1} paddingTop="safe-area-inset-top">
      <View style={{ flex: 1, paddingTop: isWeb ? 'space-0' : HEADER_HEIGHT }}>
        <Screen
          paddingHorizontal="space-0"
          paddingBottom="safe-area-inset-bottom"
        >
          <CommunityJackpot />
        </Screen>
      </View>
    </Box>
  );
}

export default CommunityJackpotScreen;
